const validWording = "Please enter valid "
const pleaseEnterWording = "Please enter "
const selectWording = "Please select "

//common
export const futureTimeErrorMsg = "Future time is not allowed"
export const futureDateErrorMsg = "Future date is not allowed"
export const DOB = validWording + "Date of Birth"
export const postalCode = validWording + "Postal Code"
export const address = validWording + "Address"
export const unitNo = validWording + "Unit Number"
export const familyLeft = validWording + "family has the Deceased left"

//supporting documents

//index
export const policyNumberLength =
  pleaseEnterWording + "8 character policy number"
export const policyNumberRequired = pleaseEnterWording + "policy number"
export const policyNumber =
  pleaseEnterWording +
  "8 character policy number starting with ‘W’ , ‘Q’ or ‘F’"
export const policyHolderName =
  validWording + "Name of Insured as per policy schedule"
export const employerAddress = validWording + "Address"
export const employerTel = validWording + "Business Tel Number"
export const gstNumber = validWording + "GST Number"

//injured person
export const claimantName = validWording + "Name"
export const claimantNricNumber = validWording + "NRIC / FIN"
export const claimantPassportNumber = validWording + "Passport Number"
export const injuredMobilePhone = validWording + "Mobile Number"
export const injuredTel = validWording + "Residential Tel Number"
export const otherInjuredOccupation = validWording + "Occupation"
export const injuredOccupation = selectWording + "Occupation"
export const dateJoin = validWording + "Date of join"

//accident details
export const accidentDate = validWording + "Date of Accident"
export const accidentTime = validWording + "Time of Accident"
export const accidentDetail = validWording + "how the accident happened"
export const machineType = validWording + "type of equipment / machinery"

//injury details
export const injuryNature = validWording + "Nature and region of injury"
export const dateCeaseWork = validWording + "valid cease work date"
export const hospitalName =
  validWording + "name of hospital that the injured person is taken to"
export const inOutPatient = validWording + "In or out-patient"
export const hospitalState =
  validWording + "state whether the injured worker still in hospital"
export const dateDischarge = validWording + "Date of Discharged"

//claimant details
export const claimantMobile = validWording + "Contact Number"
export const claimantEmail = validWording + "Email Address"
export const relationshipWithDeceased =
  validWording + "Relationship with the Deceased"

//earnings details
export const daysWorkedPerWeek = validWording + "days worked per week"

//payment details
export const bankName = validWording + "Name of Bank"
export const accountNumber = validWording + "Bank Account Number"
export const accountName = validWording + "Name of Account Holder"
